export const FETCH_REVIEWS_RESOLVED = "FETCH_REVIEWS_RESOLVED";
export const UPDATE_REVIEW_RESOLVED = "UPDATE_REVIEW_RESOLVED";
export const CREATE_REVIEW_RESOLVED = "CREATE_REVIEW_RESOLVED";
